import './chunk-455cdeae.js';
import './helpers.js';
import './chunk-e92e3389.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { T as Tooltip } from './chunk-9b0b8225.js';
export { T as BTooltip } from './chunk-9b0b8225.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Tooltip);
  }
};
use(Plugin);

export default Plugin;
